import { forwardRef } from "react";

const cellStyle = {
  border: "1.5px solid #000",
  boxSizing: "border-box",
  padding: "10px 12px",
  fontFamily: "'Times New Roman', Times, serif",
  fontSize: "20px",
  fontWeight: 600,
  color: "#000",
};

const formatDate = (value) => {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const QuotationPrintTable = forwardRef(({ record }, ref) => {
  const items = Array.isArray(record?.items) ? record.items : [];

  const formatNumber = (value) =>
    Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <div
      ref={ref}
      style={{
        display: "inline-block",
        padding: "32px 80px",
        background: "#ffffff",
      }}
    >
      <table
        style={{
          borderCollapse: "collapse",
          width: "800px",
          fontFamily: "'Times New Roman', Times, serif",
          color: "#000",
          border: "1.5px solid #000",
        }}
      >
        <tbody>
          {/* Title */}
          <tr>
            <td
              colSpan={6}
              style={{
                ...cellStyle,
                textAlign: "center",
                fontSize: "36px",
                fontWeight: 800,
                fontFamily: "Arial, Helvetica, sans-serif",
                padding: "16px 12px 8px",
                borderBottom: "none",
              }}
            >
              {record?.billTitle || "Quotation"}
            </td>
          </tr>

          {/* Date */}
          <tr>
            <td
              colSpan={6}
              style={{
                ...cellStyle,
                textAlign: "right",
                fontSize: "16px",
                fontWeight: 700,
                padding: "4px 14px 10px",
                borderTop: "none",
              }}
            >
              Date: {formatDate(record?.date)}
            </td>
          </tr>

          {/* Company Name */}
          <tr>
            <td
              colSpan={6}
              style={{
                ...cellStyle,
                textAlign: "center",
                fontSize: "24px",
                fontWeight: 700,
                padding: "10px 12px 14px",
              }}
            >
              {record?.companyName || "-"}
            </td>
          </tr>

          {/* Header */}
          <tr>
            <td
              style={{
                ...cellStyle,
                textAlign: "center",
                fontWeight: 800,
                fontSize: "21px",
                width: "50px",
              }}
            >
              Sr.No
            </td>
            <td
              style={{
                ...cellStyle,
                textAlign: "center",
                fontWeight: 800,
                fontSize: "21px",
              }}
            >
              Description of Goods
            </td>
            <td
              style={{
                ...cellStyle,
                textAlign: "center",
                fontWeight: 800,
                fontSize: "21px",
                width: "80px",
              }}
            >
              Quantity
            </td>
            <td
              style={{
                ...cellStyle,
                textAlign: "center",
                fontWeight: 800,
                fontSize: "21px",
                width: "90px",
              }}
            >
              Rate
            </td>
            <td
              style={{
                ...cellStyle,
                textAlign: "center",
                fontWeight: 800,
                fontSize: "21px",
                width: "60px",
              }}
            >
              Unit
            </td>
            <td
              style={{
                ...cellStyle,
                textAlign: "center",
                fontWeight: 800,
                fontSize: "21px",
                width: "110px",
              }}
            >
              Amount
            </td>
          </tr>

          {/* Items */}
          {items.map((item, index) => (
            <tr key={item._id ?? index}>
              <td style={{ ...cellStyle, textAlign: "center" }}>{index + 1}</td>
              <td style={cellStyle}>{item.description}</td>
              <td style={{ ...cellStyle, textAlign: "center" }}>{item.qty}</td>
              <td style={{ ...cellStyle, textAlign: "right" }}>
                {formatNumber(item.rate)}
              </td>
              <td style={{ ...cellStyle, textAlign: "center" }}>{item.unit}</td>
              <td style={{ ...cellStyle, textAlign: "right" }}>
                {formatNumber(item.amount)}
              </td>
            </tr>
          ))}

          {/* Total */}
          <tr>
            <td
              colSpan={5}
              style={{
                ...cellStyle,
                textAlign: "center",
                fontWeight: 800,
                fontSize: "21px",
              }}
            >
              Total:
            </td>
            <td
              style={{
                ...cellStyle,
                textAlign: "right",
                fontWeight: 800,
                fontSize: "21px",
              }}
            >
              {formatNumber(record?.totalAmount)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

QuotationPrintTable.displayName = "QuotationPrintTable";

export default QuotationPrintTable;
